import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconFileJs$1 = /*@__PURE__*/ proxyCustomElement(class WppIconFileJs extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-file-js", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M14.6 16.8H8.97272C8.90291 17.2561 8.70252 17.6692 8.41091 18H14.6C15.4832 18 16.2 17.2832 16.2 16.4V8.2624C16.2 7.8384 16.0312 7.4312 15.7312 7.1312L11.068 2.4688C11.056 2.45684 11.0425 2.44646 11.029 2.43616C11.0191 2.42854 11.0092 2.42096 11 2.4128C10.9432 2.3616 10.8872 2.3112 10.8248 2.2688C10.8046 2.25515 10.7824 2.24438 10.7604 2.23366C10.7476 2.22741 10.7348 2.22117 10.7224 2.2144C10.709 2.20688 10.6957 2.19917 10.6824 2.19146C10.639 2.16638 10.5955 2.14118 10.5496 2.1216C10.392 2.056 10.2224 2.0232 10.0504 2.0112C10.0346 2.01019 10.019 2.00806 10.0034 2.00593C9.98167 2.00297 9.9599 2 9.9376 2H5C4.1168 2 3.4 2.7168 3.4 3.6V11.6142C3.46532 11.6048 3.5321 11.6 3.6 11.6C3.99174 11.6 4.3459 11.7609 4.6 12.0202V3.6C4.6 3.38 4.7792 3.2 5 3.2H9.8V6.8C9.8 7.6832 10.5168 8.4 11.4 8.4H15V16.4C15 16.62 14.8208 16.8 14.6 16.8ZM14.1024 7.2H11.4C11.1792 7.2 11 7.02 11 6.8V4.0968L14.1024 7.2ZM3.6 12.4C3.93137 12.4 4.2 12.6686 4.2 13V16.4C4.2 17.2837 3.48366 18 2.6 18C1.71634 18 1 17.2837 1 16.4V16.2C1 15.8686 1.26863 15.6 1.6 15.6C1.93137 15.6 2.2 15.8686 2.2 16.2V16.4C2.2 16.6209 2.37909 16.8 2.6 16.8C2.82091 16.8 3 16.6209 3 16.4V13C3 12.6686 3.26863 12.4 3.6 12.4ZM6.56 12.4C5.69844 12.4 5 13.0984 5 13.96V14.147C5 14.6388 5.25802 15.0945 5.67971 15.3475L6.9029 16.0815C6.96314 16.1176 7 16.1827 7 16.253V16.44C7 16.6388 6.83882 16.8 6.64 16.8H6.56C6.36118 16.8 6.2 16.6388 6.2 16.44V16.4C6.2 16.0686 5.93137 15.8 5.6 15.8C5.26863 15.8 5 16.0686 5 16.4V16.44C5 17.3016 5.69844 18 6.56 18H6.64C7.50156 18 8.2 17.3016 8.2 16.44V16.253C8.2 15.7612 7.94198 15.3055 7.52029 15.0525L6.2971 14.3185C6.23686 14.2824 6.2 14.2173 6.2 14.147V13.96C6.2 13.7612 6.36118 13.6 6.56 13.6H6.64C6.83882 13.6 7 13.7612 7 13.96V14C7 14.3314 7.26863 14.6 7.6 14.6C7.93137 14.6 8.2 14.3314 8.2 14V13.96C8.2 13.0984 7.50156 12.4 6.64 12.4H6.56Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-file-js-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-file-js", "wpp-icon-file-js-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-file-js-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-file-js-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconFileJs$1);
      }
      break;
  } });
}

const WppIconFileJs = WppIconFileJs$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconFileJs, defineCustomElement };
